<template>
  <v-container fill-height fluid style="height: 100%; padding: 0;">
    <v-layout fill-height row wrap style="height: 100%;">
      <AdminSideBarMenu />
      <v-flex class="dashboard-view">
        <div v-if="isSelectedTab('general-settings')">
          <v-breadcrumbs>
            <v-breadcrumbs-item :disabled="true">Settings</v-breadcrumbs-item>
            <v-breadcrumbs-item :disabled="true">General Settings</v-breadcrumbs-item>
          </v-breadcrumbs>
          <GeneralAppearance />
        </div>
        <!-- <div v-if="isSelectedTab('landing-page')">
          <v-breadcrumbs>
            <v-breadcrumbs-item :disabled="true">Settings</v-breadcrumbs-item>
            <v-breadcrumbs-item :disabled="true">Landing Page Settings</v-breadcrumbs-item>
          </v-breadcrumbs>
          <LandingAppearance />
          <Landing class="mt-4" :settings="pages.landing_pages" />
        </div> -->
        <v-flex style="height: 100%" v-if="isSelectedTab('email-settings')">
          <v-breadcrumbs>
            <v-breadcrumbs-item :disabled="true">Settings</v-breadcrumbs-item>
            <v-breadcrumbs-item :disabled="true">Email Settings</v-breadcrumbs-item>
          </v-breadcrumbs>
          <EmailSettings/>
        </v-flex>
        <v-flex style="height: 100%" v-if="isSelectedTab('opportunities')">
          <v-breadcrumbs>
            <v-breadcrumbs-item :disabled="true">Settings</v-breadcrumbs-item>
            <v-breadcrumbs-item :disabled="true">Opportunities Settings</v-breadcrumbs-item>
          </v-breadcrumbs>
          <Opportunities :settings="pages.opportunities" />
        </v-flex>

        <v-flex style="height: 100%" v-if="isSelectedTab('directory')">
          <v-breadcrumbs>
            <v-breadcrumbs-item :disabled="true">Settings</v-breadcrumbs-item>
            <v-breadcrumbs-item :disabled="true">Directory Settings</v-breadcrumbs-item>
          </v-breadcrumbs>
          <Directory :settings="pages.directory" />
        </v-flex>

        <v-flex style="height: 100%" v-if="isSelectedTab('questionnaire')">
          <v-breadcrumbs>
            <v-breadcrumbs-item :disabled="true">Settings</v-breadcrumbs-item>
            <v-breadcrumbs-item :disabled="true">Questionnaire Settings</v-breadcrumbs-item>
          </v-breadcrumbs>
          <Questionnaire :settings="pages.questionnaire" />
        </v-flex>

        <v-flex style="height: 100%" v-if="isSelectedTab('history')">
          <v-breadcrumbs>
            <v-breadcrumbs-item :disabled="true">Settings</v-breadcrumbs-item>
            <v-breadcrumbs-item :disabled="true">History Settings</v-breadcrumbs-item>
          </v-breadcrumbs>
          <History :settings="pages.history" />
        </v-flex>

        <v-flex style="height: 100%" v-if="isSelectedTab('favorites')">
          <v-breadcrumbs>
            <v-breadcrumbs-item :disabled="true">Settings</v-breadcrumbs-item>
            <v-breadcrumbs-item :disabled="true">Favorites Settings</v-breadcrumbs-item>
          </v-breadcrumbs>
          <Favorites :settings="pages.favorites" />
        </v-flex>

        <v-flex style="height: 100%" v-if="isSelectedTab('resources')">
          <v-breadcrumbs>
            <v-breadcrumbs-item :disabled="true">Settings</v-breadcrumbs-item>
            <v-breadcrumbs-item :disabled="true">Resources</v-breadcrumbs-item>
          </v-breadcrumbs>
          <Resources :settings="pages.resources" />
        </v-flex>

        <v-flex style="height: 100%" v-if="isSelectedTab('bid_alerts')">
          <v-breadcrumbs>
            <v-breadcrumbs-item :disabled="true">Settings</v-breadcrumbs-item>
            <v-breadcrumbs-item :disabled="true">Bid Alerts</v-breadcrumbs-item>
          </v-breadcrumbs>
          <BidAlert :settings="pages.bid_alerts || {}" />
        </v-flex>

        <v-flex style="height: 100%" v-if="isSelectedTab('tracking')">
          <v-breadcrumbs>
            <v-breadcrumbs-item :disabled="true">Settings</v-breadcrumbs-item>
            <v-breadcrumbs-item :disabled="true">Tracking Settings</v-breadcrumbs-item>
          </v-breadcrumbs>
          <Tracking :settings="pages.tracking" />
        </v-flex>

        <v-flex style="height: 100%" v-if="isSelectedTab('dod-contract-analytics')">
          <v-breadcrumbs>
            <v-breadcrumbs-item :disabled="true">Settings</v-breadcrumbs-item>
            <v-breadcrumbs-item :disabled="true">DoD Contract Analytics Settings</v-breadcrumbs-item>
          </v-breadcrumbs>
          <dod-contract-analytics :settings="pages['dod-contract-analytics'] || {}" />
        </v-flex>

        <!-- <v-flex style="height: 100%" v-if="isSelectedTab('awarded')">
          <v-breadcrumbs>
            <v-breadcrumbs-item :disabled="true">Settings</v-breadcrumbs-item>
            <v-breadcrumbs-item :disabled="true">Awarded Settings</v-breadcrumbs-item>
          </v-breadcrumbs>
          <Awarded :settings="pages.awardedopportunities" />
        </v-flex> -->

        <!-- <v-flex style="height: 100%" v-if="isSelectedTab('recovery')">
          <v-breadcrumbs>
            <v-breadcrumbs-item :disabled="true">Settings</v-breadcrumbs-item>
            <v-breadcrumbs-item :disabled="true">Recovery Settings</v-breadcrumbs-item>
          </v-breadcrumbs>
          <Recovery :settings="pages.recoveryopportunities" />
        </v-flex> -->

        <!-- <v-flex style="height: 100%" v-if="isSelectedTab('forecast')">
          <v-breadcrumbs>
            <v-breadcrumbs-item :disabled="true">Settings</v-breadcrumbs-item>
            <v-breadcrumbs-item :disabled="true">Forecast Settings</v-breadcrumbs-item>
          </v-breadcrumbs>
          <Forecast :settings="pages.forecastopportunities" />
        </v-flex> -->
        <PageFooter />
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
  import Landing from './Pages/landing.vue'
  import LandingAppearance from './Appearance/landing.vue'
  import GeneralAppearance from './Appearance/general.vue'
  import Opportunities from './Pages/opportunities.vue'
  import Directory from './Pages/directory.vue'
  import BidAlert from './Pages/bid-alert.vue'
  import Questionnaire from './Pages/questionnaire.vue'
  import History from './Pages/history.vue'
  import Favorites from './Pages/favorites.vue'
  import DodContractAnalytics from './Pages/dod-contract-analytics.vue'
  import Tracking from './Pages/tracking.vue'
  import Resources from './Pages/resources.vue'
  import Awarded from './Pages/award.vue'
  import Recovery from './Pages/recovery.vue'
  import Forecast from './Pages/forecast.vue'
  import EmailSettings from './Pages/email-settings'
  import NavBar from './Components/NavBar.vue'
  import MainMenu from '../../../components/main-menu/MainMenuComponent.vue'
  import UserToolbar from '../../../components/Toolbar.vue'
  import AdminSideBarMenu from './Components/AdminSideBar.vue'
  import PageFooter from './Components/PageFooter.vue'

  export default {
    components: {
      Landing,
      LandingAppearance,
      GeneralAppearance,
      NavBar,
      MainMenu,
      BidAlert,
      AdminSideBarMenu,
      UserToolbar,
      Opportunities,
      Directory,
      Questionnaire,
      Resources,
      History,
      Favorites,
      DodContractAnalytics,
      Tracking,
      Awarded,
      EmailSettings,
      Recovery,
      Forecast,
      PageFooter
    },
    computed: {
      pages () {
        return this.$store.getters.getPages
      },
      styles () {
        return this.$store.getters.getStyles
      }
    },
    data: () => ({
      drawer: true,
      h1: window.title,
      itemsz: ['General Settings', 'Landing Page', 'Opportunities', 'Directory', 'Questionnaire', 'History', 'Favorites', 'Tracking', 'Awarded', 'Recovery', 'Forecast'],
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.'
    }),
    methods: {
      onDismiss () {
        this.$store.dispatch('setError', null)
        this.$store.dispatch('setProcess', 'null')
      },
      triggerDrawer () {
        this.drawer = !this.drawer
      },
      isSelectedTab (tabName) {
        const urlSection = this.$route.params.id || 'general-settings'
        return tabName === urlSection
      }
    },
    mounted () {
      const payload = {
        meta: {
          'h1': 'Settings/Configuration',
          'title': 'Settings/Configuration',
          'description': 'Admin Settings',
          'keywords': '',
          'requiresAuth': true
        }
      }
      document.title = payload.meta.title
      this.$store.commit('setHeaderInfo', payload)
    }
  }
</script>
<style scoped>
  #tab-item {
    min-width: 18px;
    font-size: 12px;
  }

  #body_view {
    margin-top: 71px;
  }
</style>



// WEBPACK FOOTER //
// PagesView.vue?3f3cd1c0